import { resolveCatalogPrice } from './priceCatalog.js';
import { resolveCheckoutUpdates } from './subscriptionPlan.js';
import { ADDON_PRODUCTS } from './config.js';

// AI Connect (MCP) purchased as its OWN subscription rather than as a line item
// on the buyer's existing plan. Mirrors resolveSignalManagerCheckout.
//
// Why standalone: a Stripe discount attaches to a SUBSCRIPTION, not to a single
// line. While MCP rode the base plan as an added line, a coupon could only be
// applied to the whole subscription — discounting the base plan along with it —
// so discount codes had to be suppressed for MCP entirely. Giving MCP its own
// subscription makes a subscription-scoped coupon target exactly MCP, which is
// what makes a code discount exactly MCP on this flow. (Coupons ride every
// purchase op now — adds/modifies attach at item level server-side — see
// useInvoicePreviewSync `hasPurchaseOps`.)
//
// Flat package, quantity always 1 — MCP is one seat per user, and the backend
// rejects quantity != 1 (billing-manager subscription_items.go).
export function buildMcpStandaloneCheckoutItems(catalog, cycle, options = {}) {
  if (!catalog || !cycle) return [];
  const price = resolveCatalogPrice(catalog, ADDON_PRODUCTS.mcp, cycle, options);
  return price?.id ? [{ price_id: price.id, quantity: 1 }] : [];
}

/**
 * Resolve a create-only plan for a standalone MCP subscription.
 *
 * Passing `[]` for subscriptions is the mechanism: with no existing subs to diff
 * against, resolveCheckoutUpdates routes every desired item into a `creates`
 * bucket, which becomes a NEW subscription (CreateSubscription carries `coupon`;
 * Modify/AddItem do not). Never diffs the buyer's trading subs, so it can't
 * disturb their base plan.
 *
 * No trial: MCP is not trial-eligible.
 *
 * @returns {object | null} plan, or null when the cycle has no live price
 */
export function resolveMcpStandaloneCheckout(catalog, cycle) {
  const items = buildMcpStandaloneCheckoutItems(catalog, cycle);
  if (items.length === 0) return null;
  return resolveCheckoutUpdates(items, [], catalog, { usedProductIds: [], skipTrial: true });
}
